<!-- eslint-disable vue/no-v-html -->
<template>
  <!-- training result item container -->
  <div class="relative mb-8 content__sections">
    <div class="flex flex-col gap-2">
      <h4 class="m-0!">
        <a
          :href="result.html_url"
          v-html="highlightedTitle"
        />
      </h4>

      <div class="caption-1" v-html="metaText"></div>

      <p class="mb-2 line-clamp-5 text-ellipsis">
        {{ result.short_description }}
      </p>
      <div
        v-html="training_icon"
      ></div>
      <a :href="result.html_url" class="link-cta -left-1">LEARN MORE</a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { ISearchResult } from './TrainingList.vue'

/**
 * Component props
 */
const props = defineProps<{
  result: ISearchResult  // training search result data
  query: string         // Search query for highlighting
}>()

/**
 * Computed property that highlights search terms in the training title
 * Wraps matching query terms in <b> tags for visual emphasis
 */
const highlightedTitle = computed(() => {
  const title = props.result.title || ''
  if (!props.query) return title
  const regex = new RegExp(`(${decodeURI(props.query)})`, 'gi')
  return title.replace(regex, '<b>$1</b>')
})

const training_categories = computed((): Record<string, any> => {
  return props.result.categories
})

const training_categories_str = computed((): string => {
  const categories = Object.values(training_categories.value)
    .map(tc => tc['tag_name'])
    .filter(Boolean)
  return categories.join(', ')
})

const delivery_methods = computed((): Record<string, any> => {
  return props.result.delivery_methods || {}
})

const delivery_method_str = computed((): string => {
  const methods = Object.values(delivery_methods.value)
    .map(dm => dm['title'])
    .filter(Boolean)
  return methods.join(', ')
})

const training_icon = computed(() => {
  let dmIconSection = ''
  for (const dmKey in delivery_methods.value) {
    let dm = delivery_methods.value[dmKey]
    dmIconSection += '<span class="course-delivery mr-1 ' + dm['training_style'] + '" >' +
      '<svg viewBox="0 0 30 30" class="' + dm['training_icon'] +  '" title="' + dm['training_icon'] +  '" aria-labelledby="title">' +
        '<use href="#' + dm['training_icon'] +  '"></use>' +
      '</svg>' +
      '</span>'


  }
  return dmIconSection
})

/**
 * Combines publication date and type into a formatted metadata string
 * Uses bullet separator between date and type when both are available
 */
const metaText = computed(() => {
  if (delivery_method_str.value && training_categories_str.value) {
    return `<span class="typeFilter">${delivery_method_str.value.toUpperCase()}</span>` +
    `<span class="px-1">\u00a0\u2022\u00a0</span><span class="technicalAreaFilter">${training_categories_str.value.toUpperCase()}</span>`
  } else if (delivery_method_str.value) {
    return delivery_method_str.value.toUpperCase()
  } else if (training_categories_str.value) {
    return training_categories_str.value.toUpperCase()
  }
  return ''
})

</script>
